import { memo } from 'react';
import { NavSectionHorizontal } from '../../../components/nav-section';
import useAuth from '../../../hooks/useAuth';
import { isMaster } from '../../../utils/perfil';
import { navConfigAdmin, navConfigCliente, navConfigAdminPlus } from './NavConfig';

/* ============================================================================
   Faixa do menu horizontal - visual novo.

   Substitui AppBar do MUI. Fica logo abaixo da faixa superior; o shell reserva o
   dobro da altura de `--gps-topbar-h` no `padding-top` do conteudo, por isso as
   duas nao se sobrepoem.

   BUG ANTIGO (registrado em 12/08/2026) que continua corrigido: este arquivo
   importava `navConfig` como export DEFAULT de ./NavConfig, que nunca existiu - so
   os nomeados. O webpack do Next avisava e seguia entregando `undefined`, e trocar
   o layout quebrava o menu. A escolha por perfil abaixo espelha NavbarVertical.
   ============================================================================ */

function NavbarHorizontal() {
  const { user } = useAuth();

  const navConfig = isMaster(user)
    ? navConfigAdminPlus
    : Number(user?.perfil) === 0
      ? navConfigCliente
      : navConfigAdmin;

  return (
    <div
      className="fixed left-0 right-0 z-[1050] border-b border-line bg-surface px-3 py-1"
      style={{ top: 'var(--gps-topbar-h)' }}
    >
      <NavSectionHorizontal navConfig={navConfig} />
    </div>
  );
}

export default memo(NavbarHorizontal);
